import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  fullWidth?: boolean;
  secondary?: boolean;
  showPrice?: boolean;
  href?: string;
}
export const Button = ({
  children,
  onClick,
  fullWidth,
  secondary,
  showPrice = false,
  href
}: ButtonProps) => {
  const className = `
    ${secondary ? 'bg-white text-blue-600 border-2 border-blue-600 hover:bg-blue-50' : 'bg-gradient-to-r from-blue-600 to-blue-700 text-white hover:from-blue-700 hover:to-blue-800'}
    ${fullWidth ? 'w-full' : ''}
    px-8 py-4 rounded-xl font-bold transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:scale-105 hover:-translate-y-1
    inline-block text-center
  `;
  const content = <div className="flex flex-col items-center" data-id="element-107">
      <span data-id="element-108">{children}</span>
      {showPrice && <span className="text-2xl font-bold mt-1" data-id="element-109">$9.99 USD</span>}
    </div>;
  return <div className={`${fullWidth ? 'w-full' : ''} flex flex-col items-center`} data-id="element-110">
      {href ? <a href={href} className={className} target="_blank" rel="noopener noreferrer" data-id="element-111">
          {content}
        </a> : <button onClick={onClick} className={className} data-id="element-112">
          {content}
        </button>}
      {showPrice && <div className="text-sm mt-3 text-center" data-id="element-113">
          <p className="text-gray-600 mb-1" data-id="element-114">
            <span className="line-through text-gray-400" data-id="element-115">
              Valor total: $59.96 USD
            </span>
          </p>
          <p className="text-gray-600 mb-1" data-id="element-116">
            <span className="text-gray-700" data-id="element-117">
              (Libro principal $29.99 + Bonos $29.97)
            </span>
          </p>
          <p className="font-bold text-orange-600 text-lg" data-id="element-118">
            ¡Solo hoy: $9.99 USD!
          </p>
          <p className="text-green-600 font-semibold" data-id="element-119">
            Ahorras $49.97 USD (83% de descuento)
          </p>
        </div>}
    </div>;
};